import {
  PaymentProviderConfig,
  ShaliachPaymentProviderItem,
  ShaliachPaymentProvidersListResponse,
  UpsertShaliachPaymentProviderPayload
} from '@sm-dashboard/types';
import instanceAxios from './axios';
import { createTestPaymentUrl, paymentProviderUrl, paymentProvidersUrl } from '../constants';

export interface TestPaymentPayload {
  amount: number;
  description: string;
  customerName: string;
  customerEmail: string;
  customerPhone?: string;
}

/**
 * Get payment provider configuration for a shaliach (legacy single + providers list)
 */
export const getShaliachPaymentProvider = async (shaliachId: number) => {
  const response = await instanceAxios.get(`${paymentProviderUrl}/${shaliachId}`);
  return response.data;
};

export const listShaliachPaymentProviders = async (
  shaliachId: number
): Promise<ShaliachPaymentProvidersListResponse> => {
  const response = await instanceAxios.get(`${paymentProvidersUrl}/${shaliachId}`);
  return response.data;
};

/**
 * Update payment provider configuration for a shaliach (legacy — upserts default)
 */
export const updateShaliachPaymentProvider = async (shaliachId: number, config: PaymentProviderConfig) => {
  const response = await instanceAxios.put(`${paymentProviderUrl}/${shaliachId}`, config);
  return response.data;
};

export const createShaliachPaymentProvider = async (
  shaliachId: number,
  payload: UpsertShaliachPaymentProviderPayload
): Promise<{ provider: ShaliachPaymentProviderItem }> => {
  const response = await instanceAxios.post(`${paymentProvidersUrl}/${shaliachId}`, payload);
  return response.data;
};

export const updateShaliachPaymentProviderById = async (
  shaliachId: number,
  providerId: number,
  payload: Partial<UpsertShaliachPaymentProviderPayload>
): Promise<{ provider: ShaliachPaymentProviderItem; archivedProviderId?: number }> => {
  const response = await instanceAxios.put(`${paymentProvidersUrl}/${shaliachId}/${providerId}`, payload);
  return response.data;
};

export const deleteShaliachPaymentProviderById = async (shaliachId: number, providerId: number) => {
  const response = await instanceAxios.delete(`${paymentProvidersUrl}/${shaliachId}/${providerId}`);
  return response.data;
};

export const setDefaultShaliachPaymentProvider = async (shaliachId: number, providerId: number) => {
  const response = await instanceAxios.put(`${paymentProvidersUrl}/${shaliachId}/${providerId}/default`);
  return response.data;
};

/**
 * Delete all payment provider configuration for a shaliach
 */
export const deleteShaliachPaymentProvider = async (shaliachId: number) => {
  const response = await instanceAxios.delete(`${paymentProviderUrl}/${shaliachId}`);
  return response.data;
};

/**
 * Test payment provider connection for a shaliach (default or specific id)
 */
export const testShaliachPaymentProvider = async (shaliachId: number, providerId?: number) => {
  const url =
    providerId != null
      ? `${paymentProvidersUrl}/${shaliachId}/${providerId}/test`
      : `${paymentProviderUrl}/${shaliachId}/test`;
  const response = await instanceAxios.post(url);
  return response.data;
};

/**
 * Create a test payment with shaliach's provider
 */
export const createTestPayment = async (shaliachId: number, payload: TestPaymentPayload) => {
  const response = await instanceAxios.post(`${createTestPaymentUrl}/${shaliachId}`, {
    ...payload,
    successRedirectUrl: `test/payment-shaliach/${shaliachId}/success`,
    failedRedirectUrl: `test/payment-shaliach/${shaliachId}/failed`
  });
  return response.data;
};
